<app-header></app-header>
<app-leftsidebar></app-leftsidebar>
<div class="common-page-main">
  <div class="common-herobanner">
    <img src="assets/images/cpbanner.png" alt="" />
  </div>
  <div class="right-sec common-right-sec right-slide">
    <div class="common-right-sec-bg">
      <div class="common-sec-heading">
        <h2>FAQ</h2>
        <div class="common-btn-sec">
          <a class="btn btn-dark" routerLink="/home">Back</a>
        </div>
      </div>
      <div class="common-content">
        <div class="">
          <h5>What is WorldTumbler?</h5>
          <p>WorldTumbler is a community-first platform for tabletop role-playing games. Share living worlds on
            collaborative maps, buy and sell in a multivendor storefront where anyone can be a reseller, and join the
            conversation on a social feed—maps, store, and discussion built as one community.</p>
        </div>
        <div class="">
          <h5>Who can use this platform?</h5>
          <p>The platform is designed for all involved in TTRPG - Game Masters, Players, World Builders and Content
            Creators.</p>
        </div>
        <div class="">
          <h5>System requirements?</h5>
          <p>Internet connection and browser (Chrome recommended).</p>
        </div>
        <div class="">
          <h5>Is WorldTumbler compatible with all TTRPG systems?</h5>
          <p>The platform supports systems like D&D, Pathfinder, etc but can easily extend to other game systems.
            WorldTumbler is game system-agnostic as the ‘Game System' selected serves as a filter for world content
            displayed on a map. </p>
        </div>
        <div class="">
          <h5>Do I need prior cartography or design experience to use the platform?</h5>
          <p>Nope!. As a GM you can create a game in less than 5 minutes. Starting the game after creating is a two
            click process. Players populate their character page and join the game in under 5 minutes.</p>
        </div>
        <div class="">
          <h5>Can I upload my own assets?</h5>
          <p>Yes! Anyone can upload assets, modules, NPC's, characters, Markers. Subscription is required to add world
            maps.</p>
        </div>
        <div class="">
          <h5>Does the platform support collaborative editing?</h5>
          <p>Sort of. Anyone in the community can upload content to WorldTumbler maps however only a map owner can
            officially “edit” a map. GMs and players can work on a map simultaneously and specific information is shown
            at specific times to the different groups/individuals.</p>
        </div>
        <div class="">
          <h5>Are the maps interactive?</h5>
          <p>Yes, WorldTumbler is a digital mapping platform where you trace your journey, add journal entries, create
            NPC's, add adventure content / modules, that others can see on the map. Interactivity consists of these
            items plus landmark pins, notes, and map reveals during gameplay.</p>
        </div>
        <div class="">
          <h5>What kind of visibility controls are available?</h5>
          <p>Big topic - Ask that you take a look around.</p>
          <p>GMs can see the world map, move the game token and add content where they choose.</p>
          <p>Players are limited in their view through a fog of war based on the party. They can add details to the
            journey line and add content.</p>
          <p>Everyone can look around WorldTumbler sponsored maps.</p>
          <p>Uploaded maps will only be visible to the subscriber and invited players of that map. Areas, adventures,
            etc will be discovered while playing through fog of war.</p>
          <p>Open to your suggestions of course!</p>
        </div>
        <div class="">
          <h5>Does it support mobile and tablet use?</h5>
          <p>Current version is designed for desktop and tablets. You can use it on small devices but it might not look
            pretty. </p>
        </div>
        <div class="">
          <h5>Can I create custom geography, cultures, and religions?</h5>
          <p>Subscribers at certain level can upload maps created in Azgaar's Fantasy Map Generator (AFMG).
            <LINK>. AFMG allows editing Geography, Biome, Religion, Cultures, and more. Editing needs to occur before
            uploading to the WorldTumbler system. Keep a copy of your map!
          </p>
        </div>
        <div class="">
          <h5>Can I create custom cities?</h5>
          <p>Not yet... We are considering a way for subscribers who have uploaded world maps to replace city maps prior
            to any content being added in that city. It would be problematic to the characters timeline to change the
            map after content is added.</p>
        </div>
        <div class="">
          <h5>Are there pre-made templates or assets available?</h5>
          <p>Maps - WorldTumbler has published a sponsored world called Ashmorrow. Ashmorrow can be found in the Game
            Master -> Maps list and should be the map for all games during public beta. Content - As the community
            creates content it becomes available for use. Add a Wizarding shop in a berg labeled as D&D 5e content when
            an adventure party ride through that city the shop map marker appears. Add a chain of Inn called the
            Wanderers Haven that is in most every major city, abandoned wilderness temple, start building!</p>
        </div>
        <div class="">
          <h5>Does the platform use generative AI for Characters?</h5>
          <p>We respect artists and let the user decide. AI tokens are included in all membership levels and we ask you
            before generating AI content. If you create a character for instance and click the generate button for a
            character image, a pop-up window lets you know this will consume an AI token and stepping into the
            generative AI. If you say no and upload your own picture thats perfectly fine. Do you prefer Texas ribs or a
            St Louis ribs? If you have ideas we are open.</p>
        </div>
        <div class="">
          <h5>Does the platform use generative AI for Worlds:</h5>
          <p>This is a more difficult topic as Worlds are vast. WorldTumbler, as well as Azgaar's FMG and Watabou's
            Procgen Arcana use extensive programatic work to generate maps, cities, resources, industries, etc. However
            when you upload a map that has 20 religions, 10 cultures, 15 Political States, 200 burgs we offer the AI
            tokens to help you out. We use AI prompts to create information based on all the programatic data. We
            approach this as a template allowing the community, the opportunity to improve the work in what we hope will
            be a wiki style community editing approach.</p>
        </div>
        <h5>Sharing:</h5>
        <div class="">
          <h5>Can I share my maps with others?</h5>
          <p>Exactly the point. You can upload your map(s) and digital content and invite people to play in games where
            you are the GM. We are working to allow Map owners to invite other GM's to run games in subscriber maps.</p>
        </div>
        <div class="">
          <h5>How do I publish content to the platform's community?</h5>
          <p>We make it simple. WorldTumbler is designed around the community, so adding content is simple and everyone
            can participate from day 1.</p>
          <p>From all subscription level when in a map window simply Right click and select create content. Walk through
            the steps, upload maps/descriptions if appropriate and, Viola!</p>
          <p>Our hope is that the community will create living, breathing worlds that can be shared by all. That being
            said, several ways to share content include.</p>
        </div>
        <div class="">
          <h5>Can I export maps to use offline?</h5>
          <p>No. The secrete sauce is in the online community.</p>
        </div>
        <div class="">
          <h5>Does the platform support importing existing maps?</h5>
          <p>AFMG maps v1.106.7 or later. While we beta this feature we might need to help as its a hefty process.</p>
        </div>
        <div class="">
          <h5>What happens to my content and maps if I cancel my subscription?</h5>
          <p>We prioritize a chronological Character storyline. Here is what we do to preserve that storyline on account
            downgrades.</p>
          <p>All subscription levels can support content so this information remains tied to your account.</p>
          <p>Characters will be placed back into the players character compendium with an ‘orphaned' map identifier. We
            are working on allowing.</p>
          <p>Characters moving from Map to Map is on the roadmap and will be announced when ready.</p>
          <p>Journal entries will be transferred to individual character so chronological storyline is maintained.</p>
          <p>Uploaded subscriber Maps, Games, NPC running on the map will be deleted Content created will be orphaned
            and remain tied to the account and available in public content search.</p>
          <p>During downgrade, If you exceed the number of characters allowed at your new subscription level you will be
            asked to delete characters.</p>
          <p>During downgrade, If you exceed the number of Games allowed at your new subscription level you will be
            asked to delete games.</p>
        </div>
        <div class="">
          <h5>What are the pricing plans?</h5>
          <p>Please see the subscription page.</p>
        </div>
        <div class="">
          <h5>Is there a free trial?</h5>
          <p>Everyone gets Adventurer tier for free! Maintain a couple characters, run a game, create lots of content.
          </p>
        </div>
        <div class="">
          <h5>How can I get help if I have an issue?</h5>
          <p>There are several community support options for assistance. Look to:</p>
          <p>Discord servers</p>
          <p>Reddit</p>
        </div>
        <div class="">
          <h5>Can I request new features?</h5>
          <p>Yes, look to the Discord channel for the new Features.</p>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>